export { default } from './Wallets';
